/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type DeviceLogsQueryVariables = Types.Exact<{
  accessRequestId: Types.Scalars['ID'];
  pageSize?: Types.InputMaybe<Types.Scalars['Int']>;
  pageNumber?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type DeviceLogsQuery = { __typename: 'Query', serviceAdminDeviceLogs: { __typename: 'ServiceAdminDeviceLogPayload', totalCount: number, results: Array<{ __typename: 'ServiceAdminDeviceLog', id: string, organizationName: string, customerName: string, deviceId: string, startTime: any, endTime?: any | null, startedByEmail: string, status: Types.ServiceAdminDeviceLogStatus, logUrl?: string | null }> } };


export const DeviceLogsDocument = gql`
    query DeviceLogs($accessRequestId: ID!, $pageSize: Int, $pageNumber: Int) {
  serviceAdminDeviceLogs(
    accessRequestId: $accessRequestId
    pageSize: $pageSize
    pageNumber: $pageNumber
  ) {
    totalCount
    results {
      id
      organizationName
      customerName
      deviceId
      startTime
      endTime
      startedByEmail
      status
      logUrl
    }
  }
}
    `;

/**
 * __useDeviceLogsQuery__
 *
 * To run a query within a React component, call `useDeviceLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceLogsQuery({
 *   variables: {
 *      accessRequestId: // value for 'accessRequestId'
 *      pageSize: // value for 'pageSize'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useDeviceLogsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DeviceLogsQuery, DeviceLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DeviceLogsQuery, DeviceLogsQueryVariables>(DeviceLogsDocument, options);
      }
export function useDeviceLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeviceLogsQuery, DeviceLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DeviceLogsQuery, DeviceLogsQueryVariables>(DeviceLogsDocument, options);
        }
export type DeviceLogsQueryHookResult = ReturnType<typeof useDeviceLogsQuery>;
export type DeviceLogsLazyQueryHookResult = ReturnType<typeof useDeviceLogsLazyQuery>;
export type DeviceLogsQueryResult = ApolloReactCommon.QueryResult<DeviceLogsQuery, DeviceLogsQueryVariables>;